import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7b18288e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=7b18288e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18288e",
  null
  
)

export default component.exports